var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgOpenNewBold = function SvgOpenNewBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0002 3.79995C3.88974 3.79995 3.8002 3.88949 3.8002 3.99995V9.99995C3.8002 10.1104 3.88974 10.2 4.0002 10.2H10.0002C10.1107 10.2 10.2002 10.1104 10.2002 9.99995V7.36359H11.8002V9.99995C11.8002 10.9941 10.9943 11.8 10.0002 11.8H4.0002C3.00608 11.8 2.2002 10.9941 2.2002 9.99995V3.99995C2.2002 3.00584 3.00608 2.19995 4.0002 2.19995H6.63656V3.79995H4.0002Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2002 4.939V5.99995H11.8002V2.19995H8.0002V3.79995H9.0765L5.34368 7.53277L6.47506 8.66414L10.2002 4.939Z",
    fill: "currentColor"
  })));
};

export { SvgOpenNewBold as ReactComponent };
export default __webpack_public_path__ + "63d431874b2dbed4b54ece34de0b1464.svg";